/* istanbul ignore file */
import { CURRENCY_TYPES } from '../constants';
import { EnumDropdown, EnumDropdownProps } from 'framework/form';

const CurrencyDropdown = (props: Omit<EnumDropdownProps, 'options'> & { options?: Dictionary<string> }) => {
  const options = { ...CURRENCY_TYPES };

  return <EnumDropdown options={options} placeholder="Select currency" {...props} />;
};

export default CurrencyDropdown;
